const module = {
  routes: [
    {
      path: '/',
      component: () => import('@/modules/home/pages/index.vue'),
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
